import Marionette from "backbone.marionette";

import importTpl from "views/import/importView.ejs";
import CSS from "views/import/import.css";

import FileUploadModel from "models/fileuploadModel.js";
var fileuploadModel = new FileUploadModel();

import S from "session/session.js";
import T from "session/token.js";

export default Marionette.View.extend({
    template: importTpl,
    render: function() {
        $('.content-wrapper').css({ 'margin-left': '230px' });

        // Remove active menu items
        $(".sidebar li").removeClass("active");
        $(".sidebar li").removeClass("menu-open");
        $(".sidebar li > ul").removeClass("menu-open").css("display", "none");
        // Add active menu items
        $("#IMPORT").parent().addClass("active");
        this.$el.html(this.template({
            lang: S.userInfo.attributes.lang
        }));
    },
    events: {
        "change .fileToUpload": "checkFile",
        "click .upload": "uploadFile",
        "click .download": "downloadTemplate"
    },
    data: null,
    checkFile: function(ev) {
        var name = $(ev.target).attr("name");

        var reader = new FileReader();
        var file = ev.target.files[0];
        if (!file)
            return;

        var extension = file.name.split(".");
        extension = extension[extension.length - 1];

        if (extension !== "csv") {
            $(".message#" + name).html('<div class="alert alert-danger">' +
                'El formato del archivo no es correcto, debe ser formato Excel XML (xlsx)</div>');
            $(".upload#" + name).prop("disabled", true);
            return;
        }

        reader.readAsDataURL(file);
        reader.onload = function() {
            this.data = reader.result;
            $("#" + name + ".message").html('<div class="alert alert-success">' +
                'Haga click en subir para comenzar.</div>');
            $(".upload#" + name).prop("disabled", false);
        }.bind(this);
    },
    uploadFile: function(ev) {
        var name = $(ev.target).attr("id");

        $("#loadContainer").show();
        var xhr = new XMLHttpRequest();
        xhr.open('POST', "api/import/index.php", true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);

        xhr.onload = function(e) {
            $("#loadContainer").hide();
            switch (this.status) {
                case 200:
                case 201:
                    $("#" + name + ".message").html('<div class="alert alert-success">' +
                        '<b>Archivo importado con éxito</b></div>');
                    break;
                case 500:
                    $("#" + name + ".message").html('<div class="alert alert-danger">' +
                        '<b>Hubo un error en la importación. Las cabeceras del archivo no tienen las columnas correctas.</b> Detalle: ' + this.responseText + '</div>');
                    break;
                case 400:
                    $("#" + name + ".message").html('<div class="alert alert-danger">' +
                        '<b>Los datos subidos no tienen el formato correcto</b></div>');
                    break;
                case 401:
                    $("#" + name + ".message").html('<div class="alert alert-danger">' +
                        '<b>No tiene permisos para importar</b></div>');
                    break;
            }
        };

        xhr.upload.onprogress = function(e) {
            if (e.lengthComputable) {
                var progress = (e.loaded / e.total) * 100;
                $("#progress").width(progress + "%");
            }
        };

        xhr.upload.onerror = function(e) {
            console.log("error", e);
            $("#loadContainer").hide();
        };

        xhr.onerror = function(e) {
            console.log(e);
        };

        var fd = new FormData();
        fd.append("instanceId", S.instanceId);
        fd.append("table", name);
        fd.append("fileToUpload", $(".fileToUpload#" + name)[0].files[0]);
        xhr.send(fd);
    },
    downloadTemplate: function(ev) {
        var name = $(ev.target).attr("id");
        var xhr = new XMLHttpRequest();
        xhr.open('GET', 'files/templates/' + name + '.csv', true);
        xhr.setRequestHeader('Authorization', 'Bearer ' + S.token);
        xhr.responseType = 'arraybuffer';
        xhr.onload = function(e) {
            if (this.status == 200) {
                var blob = new Blob([this.response]);
                var link = document.createElement('a');
                link.href = window.URL.createObjectURL(blob);
                link.download = name + ".csv";
                link.click();
            }
        };

        xhr.onerror = function(e) {
            console.log(e);
        }

        xhr.send();
    }
});


//////////////////
// WEBPACK FOOTER
// ./app/views/import/importView.js
// module id = 184
// module chunks = 0